import React from 'react';
import imag from '../StyledComponents/img/logo (11).png';
import { useNavigate, Link } from 'react-router-dom'; // Import Link from react-router-dom

function PrivacyPolicy() {
  return (
    <div className="log-in-main">
      <div className="log-in-inner">
        <div className="top">
          <div className="top-inner">
            <div className="logo">
              <img src={imag} alt="Whooska Logo" className="logo-w"  />
            </div>
          </div>
        </div>

        {/* Privacy Policy Content */}
        <div className="privacy-policy-content">
          <div className="privacy-policy-last-updated">
            <strong>Last updated:</strong> December 22, 2024
          </div>

          <div className="privacy-policy-introduction">
            <strong>Introduction</strong>
            <div>
              Whooska is dedicated to safeguarding the privacy of our users. This Privacy Policy outlines how we gather, utilize, disclose, and protect your information when you engage with our website (collectively, the "Service").
              Please read this Privacy Policy carefully. By accessing or using the Service, you acknowledge and agree to the terms and practices described herein. If you do not agree with these terms, please refrain from using our Service.
            </div>
          </div>

          <div className="privacy-policy-information">
            <strong>Information We Collect</strong>
            <div className="privacy-policy-personal-info">
              <strong>Personal Information You Provide</strong>
              <div>
                <ul>
                  <li>Identification details such as name, email address, phone number, and location.</li>
                </ul>
              </div>
            </div>

            <div className="privacy-policy-automatically-collected-info">
              <strong>Automatically Collected Information</strong>
              <div>
                <ul>
                  <li>Device details such as mobile device ID, model, and manufacturer.</li>
                  <li>Log data including search queries, IP address, browser type, and pages visited.</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="privacy-policy-use-info">
            <strong>How We Use Your Information</strong>
            <div>
              <ul>
                <li>Enhance and maintain our Service.</li>
                <li>Create and manage your user account.</li>
                <li>Communicate information related to the Service.</li>
                <li>Analyse usage trends and preferences.</li>
                <li>Identify and address technical issues and fraudulent activities.</li>
              </ul>
            </div>
          </div>

          <div className="privacy-policy-sharing-info">
            <strong>Sharing of Your Information</strong>
            <div>
              <ul>
                <li>With third-party service providers assisting us.</li>
                <li>To comply with legal obligations.</li>
                <li>To safeguard our rights and property.</li>
                <li>With your explicit consent.</li>
              </ul>
            </div>
            <div>We do not sell your personal information to third parties.</div>
          </div>

          <div className="privacy-policy-your-choices">
            <strong>Your Choices</strong>
            <div>You can modify your personal information via your account settings.</div>
          </div>

          <div className="privacy-policy-data-security">
            <strong>Data Security</strong>
            <div>
              We have put measures in place to protect your personal information from accidental loss and unauthorized access, alteration, and disclosure. However, no data transmission method over the internet is completely secure.
            </div>
          </div>

          <div className="privacy-policy-changes">
            <strong>Changes to Our Privacy Policy</strong>
            <div>
              We reserve the right to periodically update this Privacy Policy. Changes will be posted on this page with the updated "Last updated" date.
            </div>
          </div>

          <div className="privacy-policy-contact">
            <strong>Contact Us</strong>
            <div>
              For any inquiries regarding this Privacy Policy, reach out to us at: info@whooska.com.au
            </div>
          </div>
        </div>

        {/* Bottom Content */}
        <div className="bottom">
          <div className="bottom-inner">
            <div className="text-content">
              <div className="copy">copyright @ WhooshkaTips</div>
              <div className="text">
                This page is for 18+ only. Gamble Responsibly. Visit{" "}
                <span>www.gamblinghelponline.org.vic.au</span> or call <br />
                Gambling Help on <span>1800 858 858</span> The chances are you are about to lose
              </div>
              <div className="policy-container">
                <div className="policy">

                  <Link to="/whooska/admin/Terms/of/Service">Terms & Conditions</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
